// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__c9wP9","heading":"LearnWin_heading__FE5n+","subheading":"LearnWin_subheading__FqHDE","grid":"LearnWin_grid__17xE0","card":"LearnWin_card__fVKYq"};